import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Typography, Button } from '@mui/material'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

interface MenuAccordionProps {
    header: React.ReactNode,
    avaible: boolean,
    children?: React.ReactNode,
    expanded?: boolean,
    icon?: IconProp,
    inactive: boolean
}

export default function MenuAccordion({ header, avaible, children, inactive, expanded = false, icon = 'arrow-right' }: MenuAccordionProps) {
    const [active, setActive] = useState(expanded)
    return <div className={`custom-accordion ${inactive && 'inactive'}`} >
        <div className={`custom-accordion-header ${avaible && 'avaible'}`} >
            {avaible ? <Button onClick={() => setActive(exp => !exp)} className="custom-accordion-header-control" size='small'>
                <FontAwesomeIcon icon={icon} className={`m-auto  ${active && 'active-arrow'}`} />
            </Button> : <div className='custom-accordion-header-wait'><FontAwesomeIcon icon="folder-open" /></div>}
            <Typography variant='body1' component='div' sx={{ width: '100%' }}>{header}</Typography>
        </div>
        <div className={`custom-accordion-content ${active && 'expanded'}`}>{children}</div>
    </div>
}